const GeoType = Object.freeze({
  CONTINENT: 'CONTINENT',
  SUBCONTINENT: 'SUBCONTINENT',
  COUNTRY: 'COUNTRY',
  STATE: 'STATE',
  COUNTY: 'COUNTY',
  CITY: 'CITY',
  UNKNOWN: 'UNKNOWN',
  DMA: 'DMA'
})
export default GeoType
// RESERVE BELOW
